export type CurrencyLike = number | string | null | undefined;

export type CostPieDatum = {
  type?: string;
  name?: string;
  value?: CurrencyLike;
};

export const formatAnalyticsCurrency = (value: CurrencyLike) => {
  if (value === null || value === undefined) {
    return '-';
  }
  const numericValue = typeof value === 'number' ? value : Number(value);
  if (Number.isNaN(numericValue)) {
    return '-';
  }
  return `¥${numericValue.toLocaleString()}`;
};

export const buildCostPieLabelConfig = () => ({
  position: 'outside' as const,
  text: (datum: CostPieDatum) => {
    const label = datum.type ?? datum.name ?? '-';
    return `${label} ${formatAnalyticsCurrency(datum.value)}`;
  },
});
